import React, { memo } from "react";
import { useTranslation } from "react-i18next";

interface ReportSeparatorProps {
  onEdit?: () => void;
  canEdit?: boolean;
}

const ReportSeparator: React.FC<ReportSeparatorProps> = memo(({ onEdit, canEdit }) => {
  const { t } = useTranslation();
  
  return (
    <div className="cleanup-separator">
      <hr />
      <span>{t("report.reportInformation")}</span>
      {canEdit && onEdit && (
        <button className="separator-edit-btn" onClick={onEdit} title="Edit report">
          <img
            src={`${process.env.PUBLIC_URL}/images/edit_prod.png`}
            alt="Edit"
            className="separator-edit-icon"
          />
        </button>
      )}
    </div>
  );
});

ReportSeparator.displayName = "ReportSeparator";

export default ReportSeparator;

